import ChevronDownIcon from 'assets/icons/chevron-down-2.svg';
import { ListedPropertyDetailMemberAuctionProperty, ListedPropertyRoomGetAssessmentDetail} from 'domain/entities/PropertyEntity';
import { useCollapse } from 'react-collapsed';
import { PropertyDescription } from './PropertyDescription';
interface props {
    detailAssessment?: ListedPropertyDetailMemberAuctionProperty;
    detailRoomAssessment?: ListedPropertyRoomGetAssessmentDetail;
}

export const CollapseDetail = ({ detailAssessment, detailRoomAssessment }: props) => {
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();
    return (
        <>
            <div {...getToggleProps()}>
                <section className="button-style" style={{ marginBottom: 24 }}>
                    <section
                        style={{
                            height: 24,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginTop: 32,
                        }}
                    >
                        <div className="pd-title border-bottom-des">物件概要</div>
                        <div className="button-style center-inside" style={{ marginLeft: 8 }}>
                            <img
                                alt=""
                                src={ChevronDownIcon}
                                className={`collapse-icon ${
                                    isExpanded ? 'collapse-icon-active' : ''
                                }`}
                            />
                        </div>
                    </section>
                </section>
            </div>
            <div {...getCollapseProps()}>
                <section
                    className="content"
                    style={{
                        width: '100%',
                        height: 'fit-content',
                    }}
                >
                    <PropertyDescription detailAssessment={detailAssessment} detailRoomAssessment={detailRoomAssessment} />
                </section>
            </div>
        </>
    );
};
